import { render, staticRenderFns } from "./TestimonialsList.vue?vue&type=template&id=8c4ceb66"
import script from "./TestimonialsList.vue?vue&type=script&lang=js"
export * from "./TestimonialsList.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsList.vue?vue&type=style&index=0&id=8c4ceb66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports